// extracted by mini-css-extract-plugin
module.exports = {"RepoSelector":"RepoSelector_RepoSelector__1A--G","repoList":"RepoSelector_repoList__3MvPr"};